// Copyright © 2021 Move Closer
export var AlertTheme;
(function (AlertTheme) {
    AlertTheme["Danger"] = "danger";
    AlertTheme["Info"] = "blue";
    AlertTheme["Primary"] = "primary";
    AlertTheme["Success"] = "green";
    AlertTheme["Warning"] = "warning";
})(AlertTheme || (AlertTheme = {}));
